import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PMA_DATA_CONFIG } from './pma-data-config.token';
import { PmaDataConfig } from './pma-data.module';
import {
  GetFactsResponse,
  PmaGateway,
} from '@prlw/core/pma/pma-gateway.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpPmaGateway implements PmaGateway {
  constructor(
    @Inject(PMA_DATA_CONFIG) private readonly config: PmaDataConfig,
    private readonly http: HttpClient,
  ) {}

  getFacts(): Observable<GetFactsResponse> {
    return this.http.get<GetFactsResponse>(`${this.config.apiPrefix}/facts`);
  }
}
